import { BiErrorCircle } from 'react-icons/bi';
import PARCIcon from '../../public/assets/PARC.svg';
import { HStack, Text, VStack } from 'ui_2';
import { RecordWithPlaintext } from '@puzzlehq/sdk';

type Props = {
  balance?: number;
  parcRecord?: RecordWithPlaintext;
};
export const PARCBalance = ({ balance, parcRecord }: Props) => {
  if (balance !== undefined) {
    return (
      <VStack className='items-end'>
        <HStack
          className={`h-fit items-center rounded-[5px] bg-gray-100 pl-1 pr-4`}
        >
          <img src={PARCIcon} width={44} height={44} />
          <Text font={'md'} className='text-gray-700'>
            {balance} PARC
          </Text>
        </HStack>
        {balance === 0 ||
          (parcRecord?.plaintext === undefined && (
            <HStack className='items-center gap-1'>
              <BiErrorCircle className='text-red-400' size={14} />
              <Text color='red'>Low PARC Balance!</Text>
            </HStack>
          ))}
      </VStack>
    );
  }
};
